<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P0003601.installation.filtration.titre' | translate"
      [description]="'P0003601.installation.filtration.description' | translate"
    >
    </app-header-configuration>

    <app-label-configuration
      [title]="'P0003601.installation.filtration.programmeTitre' | translate"
      [information]="openEnSavoirPlus"
      [titleListe]="'P0003601.installation.filtration.programme' | translate"
      [description]="
        'P0003601.installation.filtration.programmeDescription' | translate
      "
      [value]="actionStack!.getValue('fvsCProgrammeFiltrationAuto')"
      [liste]="P0003601ProgrammeFiltrationAuto"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.FiltrationVS_Controle,
          'fvsCProgrammeFiltrationAuto',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    @if (actionStack!.getValue('fvsCProgrammeFiltrationAuto') === 1) {
      <app-two-choices-control
        [title]="'P0003601.programme.horlogeHiver' | translate"
        [firstLabel]="
          'P00039.lighting.functionality.parameters.setting.title.clock.day'
            | translate
        "
        [firstValue]="0"
        [secondLabel]="
          'P00039.lighting.functionality.parameters.setting.title.clock.week'
            | translate
        "
        [secondValue]="1"
        [value]="actionStack!.getValue('fvsPTypeHorlogePPH')"
        (onChange)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.FiltrationVS_Parametrage2,
            'fvsPTypeHorlogePPH',
            $event,
            null
          )
        "
      >
      </app-two-choices-control>

      @if (this.actionStack!.getValue('fvsPTypeHorlogePPH') === 0) {
        <app-larged-link
          [name]="
            'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
              | translate
          "
          (onPress)="goToFunctionParametersSettingsClockScreen()"
        >
        </app-larged-link>
      } @else {
        <app-larged-link
          [name]="
            'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
              | translate
          "
          (onPress)="goToFunctionParametersSettingClockWeekScreen()"
        >
        </app-larged-link>
      }

      <app-label-description
        [description]="
          'P0003601.filtration.reglage.descriptionHorloge' | translate
        "
      ></app-label-description>
    }

    @if (actionStack!.getValue('fvsCProgrammeFiltrationAuto') === 2) {
      <app-two-choices-control
        [title]="'P0003601.programme.horlogeEte' | translate"
        [firstLabel]="
          'P00039.lighting.functionality.parameters.setting.title.clock.day'
            | translate
        "
        [firstValue]="0"
        [secondLabel]="
          'P00039.lighting.functionality.parameters.setting.title.clock.week'
            | translate
        "
        [secondValue]="1"
        [value]="actionStack!.getValue('fvsPTypeHorlogePPE')"
        (onChange)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.FiltrationVS_Parametrage4,
            'fvsPTypeHorlogePPE',
            $event,
            null
          )
        "
      >
      </app-two-choices-control>

      @if (this.actionStack!.getValue('fvsPTypeHorlogePPE') === 0) {
        <app-larged-link
          [name]="
            'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
              | translate
          "
          (onPress)="goToFunctionParametersSettingsClockPPEScreen()"
        >
        </app-larged-link>
      } @else {
        <app-larged-link
          [name]="
            'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
              | translate
          "
          (onPress)="goToFunctionParametersSettingClockWeekPPEScreen()"
        >
        </app-larged-link>
      }

      <app-label-description
        [description]="
          'P0003601.filtration.reglage.descriptionHorloge' | translate
        "
      ></app-label-description>
    }
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
